import { useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing } from '@zg-rentals/ts-z-calendar-client-react-query';
import type { GetTouringTreatmentForZuidAndListingWebApiRequestDto } from '@zg-rentals/ts-z-calendar-client';

type Options = {
  enabled: boolean;
  /** Names the consuming surface in error logs, e.g. 'RenterDetailsModal - Error fetching touring treatment'. */
  errorDetails: string;
};

/**
 * Fetches the touring treatment for the signed-in user and listing — gates tour-scheduling
 * upsell surfaces (see isEligibleForTourUpsell).
 */
const useTouringTreatmentForZuidAndListing = (
  postData: GetTouringTreatmentForZuidAndListingWebApiRequestDto,
  { enabled, errorDetails }: Options,
) =>
  useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing(postData, {
    enabled,
    meta: {
      context: {
        api: 'getTouringTreatmentForZuidAndListing',
        details: errorDetails,
      },
    },
  });

export default useTouringTreatmentForZuidAndListing;
